export default {
  // 學生註冊
  nameZh: 'Chinese Name or Full Name',
  nameEN: 'English Name',
  lastName: 'Surname',
  firstName: 'First Name',
  gender: 'Gender',
  female: 'Female',
  male: 'Male',
  title: 'Title',
  birthday: 'Birthday',
  phoneNumber: 'Student Contact Number',
  phoneRegion: 'Area Code ',
  account: 'Account',
  email: 'Email',
  emailTips:'【Important: Please ensure that the email address is accurate and can receive emails normally, otherwise it may affect the progress of your application】',
  emailPassword: 'Email Password',
  country: 'Country/Region',
  state: 'Province',
  city: 'City',
  region: 'District',
  postcode: 'Postal Code',
  address: 'Contact Address',
  alternativeAddr: 'Alternative Contact Address',
  fillApply: 'Save and Fill in Application Form',
  returnStuList: 'Return to the list',
  fkAreaRegion: 'Region',
  saveTemporal: "Information to be completed, temporary ",
  moreEmailTips:' (Please separate multiple email addresses with (;+space))',
  viewStudentsAddApplications:'View students and add applications',
  duplicateStudentTips:'Detected, there are {num} duplicate students!',
  viewStudentsEditThem:'View students and edit them',
  shareLink:'share link',
  notStudentEmail:'(Not Student Email)',

  // 學生資料管理
  isLivedSinceBirth: 'Have you lived in this country/region since birth?',
  fkStudentAppCountryIdLive: 'Current Country/Region',
  migrationTime: 'Migration Time',
  stayingRightTime: 'Take the right of abode time',
  isHavePassport: 'Do you have a passport',
  fkStudentAppCountryIdPassport: 'Issuing Country/Region',
  passportIssueDate: 'Issue Date',
  passportIssueExpried: 'Valid until',
  passportNumber: 'Passport Number',
  followUpPhoneCode: 'Area Code',
  followUpPhoneNumber1: "Mobile/Telphone numbe of Agent 1",
  followUpPhoneCode1: 'Area Code 1',
  followUpEmail1: 'Email of Agent 1',
  followUpPhoneNumber2: "Mobile/Telphone numbe of Agent 2",
  followUpPhoneCode2: 'Area Code 2',
  followUpEmail2: 'Email of Agent 2',
  followUpPhoneNumber3: "Mobile/Telphone numbe of Agent 3",
  followUpPhoneCode3: 'Area Code 3',
  followUpEmail3: 'Email of Agent 3',
  passportInfo: 'Passport Information',
  contactPerson: '+ New Login',
  contactNotice: '(It is suggested to provide the mobile phone number of the consultant teacher so that the system can push students\' case progress)',
  atLeastOne: '(Fill in at least one)',
  fkStudentAppCountryId: 'Nationality',
  fkStudentAppAncestryId: 'Ethnicity',
  fkStudentAppMotherLanguageId: 'Mother Language',
  fkStudentAppCountryIdBirth: 'Country/Region of Birth',
  cityBirth: 'Birth City',
  idCardNumber: 'ID Card Number',
  idCardNumberTips: '【Note: If you are a student from mainland China and need to apply to the University of Hong Kong, please be sure to enter your ID number】',
  whetherPayment:'On behalf payment?',

  regStartTime: 'Start time of filing',
  regEndTime: 'End time of filing',
  openTimeStart: 'Enrollment Start Date',
  openTimeEnd: 'Enrollment End Date',
  openTime: 'Enrollment Date',
  export: 'Export',
  applicationStatus: 'Application processing status',
  failureReason: 'Failure Reason',
  regGmtCreate: 'Created on',
  edit: 'Editor application',
  addApplyCourse: 'Add course',
  personInfo: 'Personal Information',
  applyFollow: 'Application Follow-up status',
  allDataRegiest: 'Registration of Complete Information',
  baseDataRegiest: 'Basic Registration Information',
  intelligentIdentificationStudentInfo: 'AI Identificcation',
  intelligentIdentificationTips: 'Extra information thru AI indentification',
  intelligentIdentificationTips2_1: '2. How to',
  intelligentIdentificationTips2_2: ' upload and recognition ',
  intelligentIdentificationTips2_3: '? Click the area above to upload your passport (image or PDF format).',
  intelligentTitle: '1. Please select passport country/Region.',
  uploadPassportNational: 'Upload passport pictures from other regions',
  uploadPassport: 'Upload Mainland China passport picture',
  uploadBackground: 'Upload background information',
  continuetofill: 'Manual Input',
  continueInput: 'Continue Input',
  stuName: 'Name(Chinese)',
  stuNameEn: 'Name(English)',
  stuGender: 'Gender',
  stuNation: 'Nationality',
  stuBirth: 'Birthdate',
  stuIdcard: 'Identity Card',
  stuBirthPlace: 'Birthplace',
  stuPassport: 'Passport',
  stuEduExp: 'Educational experience',
  stuWorkExp: 'Work experience',
  notUpload: 'not uploaded ',
  aiCode1:'The border of the certificate is incomplete, please upload again',
  aiCode2:'Please upload the original',
  aiCode3:'The file cannot be recognized, please upload again',
  aiCode4:'The certificate cannot be modified, please upload again',
  aiCode5:'The certificate is reflective, please upload again',
  aiCode6:'The certificate is blurred, please upload again',
  aiCode7:'The alarm capability is not enabled',
  // 文件下載
  studentInformation: 'Student Information',

  courseApplyStatus: 'Application Status',
  courseApplyStatus0: 'New',
  courseApplyStatus1: 'Submitted',
  courseApplyStatus2: 'Request For Evidence',
  courseApplyStatus3: 'Add',
  courseApplyStatus4: 'Consultant Submitted',
  // 學生資料管理
  student: 'Student',
  fkAreaCountryName: 'Country/Region',
  schoolName: 'School Name',
  courseName: 'Course Name',
  lastBmsApplyFollowStatusName: 'Current Status of Course Application',
  submitInfoStatus: 'Submission Status',
  editApplyStatus: 'Modifying Application Status',
  completed: 'Completed',
  unCompleted: 'Incomplete',
  current: 'Current',
  notStart: 'Not Start',

  // 學生申請匯總
  studentName: 'Student Name',
  studentNameZh: 'Student Name(Chinese)',
  studentNameEn: 'Student Name(English)',
  applySchoolName: 'School of Application',
  applyCourseName: 'Proposed Program',
  courseType: 'Course Type',
  bmsApplyFollowStatusName: 'Application Step Status',
  applyTotalCount: 'Total number of applications submitted',
  openingTime: 'Enrollment Time (month)',
  notISSUEStudent: 'Non-Issue Create Student',
  checkIssueStudentInfo: 'View Student Information of Old Issue',

  bindOnlineForm: 'Bind online form',
  bindSuccess: 'Binding succeeded',
  bindErr: 'Binding failed and please check data',
  inputOnlineForm: 'Please input online form id',
  inputOnlineFormErr: 'Please check input format',
  noSelectTips: 'If not found, please manual input.',
  batchTransferStudentManagementAccounts:'Batch transfer of student management accounts',
  createAccount:'Create an account',
  currentManagementAccount:'Current management account',
  transferManagementAccount:'Transfer management account',
  transferTips:'After a student is transferred, the transferred student will not be visible to the current account. Unless the current account is the parent account of the transfer account.',
  noTransferData:'There are currently no subordinate accounts to choose from.',

  applyDialogTips1: 'You have student applications pending submission！',
  applyDialogTips2: 'You currently have applications that are incomplete or not yet submitted to GEA.Please review and complete the submission so we can continue processing.',
  applyDialogTips3: 'Total',
  applyDialogTips4: 'applications pending processing',
  applyDialogTipsButton: 'Go to Process',
};
